import { combineGuardsSerial } from '../../composer/combineGuardsSerial';
import { determineI18nResourceGuard } from '../../guards/determineI18nResourceGuard';
import { determineLanguageGuard } from '../../guards/determineLanguageGuard';

import type { BaseState } from '@kc-console/context';
import type { Guard } from '../../../types';

/**
 * Onboarding 에러 페이지 가드 체인
 *
 * GSSP와 동일하게 determineLanguageGuard를 사용 (일관된 언어 결정):
 * - 토큰이 있는 경우 (500 에러 등) → IAM API 기반 사용자 설정 언어
 * - 토큰이 없는 경우 (인증 실패 등) → getCurrentLanguage 내부 쿠키 fallback
 *
 * 반환 타입 `Guard<BaseState>`:
 * - `executeInitialPropsGuards`가 `Guard<BaseState>`를 요구하므로 Account 패턴과 동일하게 명시
 * - 내부 가드들은 `Guard<ServiceAppState>` 타입이지만, `combineGuardsSerial` 내부의
 *   `as unknown as Guard<T>` 캐스팅으로 처리됨 (기존 Account 패턴과 동일한 메커니즘)
 * - 런타임에는 `ERROR_PAGE_DEFAULT_STATE`가 `ServiceAppState` 전체 필드를 가지므로 정상 동작
 */
const errorPageGuardArray = [determineLanguageGuard, determineI18nResourceGuard];

export const generateErrorPageGuards = (): Guard<BaseState> => {
  return combineGuardsSerial(errorPageGuardArray);
};
